import {langSwitch} from "../../../../core/utils/lang";
import React from "react";
import useSetDefaultOption from "../../../hooks/core/useSetDefaultOption";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {optionAction} from "../../../redux/store";
import {useNavigate, useParams} from "react-router-dom";
import callPeerRemoteModule from "../../../../core/utils/callPeerRemoteModule";


const SkipStepButton = ({preselectionList}) => {
  const langData = useSelector(state => state.theme.langData);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const connectMode = useSelector(state => state.theme.connectMode);
  const currentProduct = useSelector(state => state.optionWindow.currentVehicle);
  const {selectDefaultOption} = useSetDefaultOption();
  const defaultVehicleConfigData = preselectionList.find(item => item.isDefault);


  return (
    <button
      type="button"
      className={"skip-step preselection-arrow-right"}
      onClick={async () => {
        if (connectMode === "web") {
          dispatch(optionAction.setOptions({selection: "isGnb", value: false}));
          navigate(`/${params.lang}/${params.id}/configurator/exterior`);
        } else {
          const remoteModePeerConnected = await callPeerRemoteModule(connectMode);
          await selectDefaultOption(currentProduct && currentProduct.id, defaultVehicleConfigData.id)
          remoteModePeerConnected.conn.sendData("dispatch", { action: "optionAction", func: "setCurrentNavigation", payload: "exterior"});
        }
      }}
    >
      {langSwitch("preselection", "skipMessage", langData.lang)}
    </button>
  )
}
export default SkipStepButton;
